module.exports = __webpack_public_path__ + "img/robot-avatar.d52dad7f.png";